/* models/formatters/categorical_tick_formatter */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var tick_formatter_1 = require(116) /* ./tick_formatter */;
    var array_1 = require(24) /* ../../core/util/array */;
    var CategoricalTickFormatter = /** @class */ (function (_super) {
        tslib_1.__extends(CategoricalTickFormatter, _super);
        function CategoricalTickFormatter(attrs) {
            return _super.call(this, attrs) || this;
        }
        CategoricalTickFormatter.prototype.doFormat = function (ticks, _opts) {
            return array_1.copy(ticks);
        };
        CategoricalTickFormatter.__name__ = "CategoricalTickFormatter";
        return CategoricalTickFormatter;
    }(tick_formatter_1.TickFormatter));
    exports.CategoricalTickFormatter = CategoricalTickFormatter;
}
